module.exports = __webpack_public_path__ + "static/media/deeplearning_ai_logo.7a9b2eb0.png";